import * as Sentry from '@sentry/gatsby';
const { getSentryEnvironment, isSentryEnabled, getSentryDsn } = require('./lib/sentry');

if (isSentryEnabled()) {
  Sentry.init({
    dsn: getSentryDsn(),

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,

    integrations: [Sentry.replayIntegration()],

    replaysSessionSampleRate: 0, // Don't waste our limit replay quota on non-error sessions
    replaysOnErrorSampleRate: getSentryEnvironment() !== 'development' ? 1.0 : 0, // Capture 100% of sessions with replay, for error tracking (0% in development)

    environment: getSentryEnvironment(),

    beforeSend(event, hint) {
      const error = hint.originalException || hint.syntheticException;
      const errorMessage = error?.message || error?.toString() || '';

      // Ignore instrumentation fetch errors, these are not user-facing.
      if (errorMessage.includes('(ingesteer.services-prod.nsvcs.net)')) {
        return null;
      }

      /**
       * Gatsby loader error noise: static query JSON fetch failed.
       *
       * When the browser aborts a request (offline / flaky network / privacy tools / captive portal),
       * Sentry breadcrumbs often record it as `status_code: 0`. Gatsby treats this as "couldn't load"
       * and may also log "page resources ... not found. Not rendering React".
       *
       * We ignore ONLY the aborted-request variant (status_code === 0). If the file is truly missing
       * (404) or the server errors (5xx), those will still be reported.
       */
      const isGatsbyPageDataLoadError =
        errorMessage.includes(`We couldn't load "/page-data/`) ||
        errorMessage.includes('page resources for') ||
        errorMessage.includes('Not rendering React');

      if (isGatsbyPageDataLoadError) {
        const breadcrumbs = event?.breadcrumbs || [];
        const hasAbortedPageData = breadcrumbs.some((b) => {
          const url = b?.data?.url;
          const status = b?.data?.status_code;
          return typeof url === 'string' && url.includes('/page-data/') && status === 0;
        });

        if (hasAbortedPageData) {
          return null;
        }
      }

      return event;
    },
  });
} else {
  console.warn('Sentry is not enabled, skipping initialization');
}
